@let listVar = list();

@if (listVar) {
    <ng-container
        #slider="sliderV2"
        lsSliderV2
        [config]="config"
        [emblaRoot$]="sliderViewport"
    >
        <div
            #sliderViewport
            class="partners-slider__viewport"
            [class._gradient-end]="slider.canScrollNext()"
            [class._gradient-start]="slider.canScrollPrev()"
        >
            <div class="partners-slider__container">
                @for (icon of listVar; track icon.alias) {
                    <a
                        class="partners-slider__slide"
                        rel="dofollow"
                        target="_blank"
                        [href]="icon.url"
                    >
                        <img
                            class="partners-slider__img"
                            height="50"
                            loading="lazy"
                            [alt]="icon.title"
                            [src]="icon.image"
                        >
                    </a>
                }
            </div>
        </div>
    </ng-container>
}
